;(function module() {
  angular
    .module('app.ui.form.ctrls')
    .controller('DeleteApplicationController', [
      '$uibModalInstance',
      'applicationIds',
      'ApplicationsApi',
      'logger',
      'type',
      function controller(
        $uibModalInstance,
        applicationIds,
        ApplicationsApi,
        logger,
        type
      ) {
        var vm = this
        vm.type = type

        vm.cancel = () => {
          $uibModalInstance.dismiss('cancel')
        }

        const bulkApplicationDelete = async () => {
          const payload = {applicationIds, isDeleted: true}
          try {
            const {status} = await ApplicationsApi.bulkApplicationUpdate(
              payload
            )
            if (status === 200) {
              $uibModalInstance.close(true)
            }
          } catch (error) {
            logger.notify('error', error.data.message)
            $uibModalInstance.close(false)
          }
        }

        vm.confirmDelete = async () => {
          if (vm.confirmationInput === 'DELETE') bulkApplicationDelete()
          else if (vm.confirmationInput !== 'DELETE')
            logger.notify('warning', `Wrong confirmation text`)
        }
      },
    ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/directives/application/delete-applications/delete-application.ctrl.js